import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BookingSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [checking, setChecking] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      pollPaymentStatus();
    }
  }, [sessionId]);

  const pollPaymentStatus = async (attempts = 0) => {
    const maxAttempts = 10;
    
    if (attempts >= maxAttempts) {
      setChecking(false);
      toast.info('Payment verification is taking longer than expected. Please check your email for confirmation.');
      return;
    }

    try {
      const response = await axios.get(`${API}/payments/checkout/status/${sessionId}`);
      
      if (response.data.payment_status === 'paid') {
        setChecking(false);
        toast.success('Payment confirmed!');
        return;
      } else if (response.data.status === 'expired') {
        setChecking(false);
        toast.error('Payment session expired. Please try booking again.');
        return;
      }
      
      // Continue polling
      setTimeout(() => pollPaymentStatus(attempts + 1), 2000);
    } catch (error) {
      console.error('Error checking payment status:', error);
      setChecking(false);
      toast.error('Failed to verify payment. Please contact support if you were charged.');
    }
  };

  return (
    <div className="status-page">
      <div className="status-content">
        <div className="status-icon" style={{ color: '#22c55e' }}>
          <CheckCircle size={80} />
        </div>
        <h1 className="status-title" data-testid="success-title">Booking Confirmed!</h1>
        <p className="status-message">
          {checking ? (
            'Verifying your payment...'
          ) : (
            'Thank you for your booking. You will receive a confirmation email shortly with all the details.'
          )}
        </p>
        <button 
          className="cta-button" 
          onClick={() => navigate('/')}
          data-testid="home-button"
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default BookingSuccessPage;